import store from "@/store";

export function getBlankRecord() {
  return {
    accountBsb: null,
    accountName: null,
    accountNumber: null,
    administrationFeePerProvider: null,
    administrationFeePerStudent: null,
    levyParametersAsAtDate: null,
    inScopeCutoffDate: null,
    bpayBillerCode: null,
    created: null,
    createdBy: null,
    daysAfterInvoiceIsDueToSendPaymentOverdueWarningNotice: null,
    daysBeforeInvoiceIsDueToSendPaymentDueReminderNotice: null,
    daysInvoiceIsDueAfterGeneratingInvoice: null,
    daysAfterInvoiceIsDueToDisplayWarning: null,
    enableLevyCap: null,
    enableSanctions: null,
    enableShortRegistrationPeriodRiskFactor: null,
    id: null,
    isSetup: true,
    levyAccountsEmail: null,
    levyCap: null,
    ltpsOperationsEmail: null,
    numberOfAnnualChargeLatePaymentYears: null,
    numberOfLtpsLatePaymentYears: null,
    riskPremiumPerStudent: null,
    riskPremiumRate: null,
    specialTuitionProtectionRate: null,
    status: null,
    type: null,
    updated: null,
    updatedBy: null,
    year: null
  };
}

export function getBlankFeesRecord() {
  return {
    administrationFeePerProvider: null,
    administrationFeePerStudent: null,
    id: null,
    riskPremiumPerStudent: null,
    riskPremiumRate: null,
    specialTuitionProtectionRate: null,
    status: null
  };
}

export function getBlankInvoicingTimingConfigurationRecord() {
  return {
    levyCollectionType: null,
    daysAfterInvoiceIsDueToSendPaymentOverdueWarningNotice: null,
    daysBeforeInvoiceIsDueToSendPaymentDueReminderNotice: null,
    daysInvoiceIsDueAfterGeneratingInvoice: null,
    daysAfterInvoiceIsDueToDisplayWarning: null
  };
}

export function getBlankLevyCalculationTimingConfigurationRecord() {
  return {
    levyCollectionType: null,
    levyParametersAsAtDate: null,
    inScopeCutoffDate: null
  };
}

export function getBlankInvoiceConfigurationRecord() {
  return {
    accountBsb: null,
    accountName: null,
    accountNumber: null,
    bpayBillerCode: null
  };
}

export function getBlankEmailConfigurationRecord() {
  return {
    levyAccountsEmail: null,
    ltpsOperationsEmail: null
  };
}

export function getBlankDataSourceConfigurationRecord() {
  return {
    useSpreadsheetForInScopeProviders: null,
    useSpreadsheetForLevyParameters: null,
    numberOfLtpsLatePaymentYears: null,
    numberOfAnnualChargeLatePaymentYears: null
  };
}

export function getBlankPublicLevyEstimatorConfiguration() {
  return {
    enablePublicLevyEstimator: null
  };
}

export function getBlankNonComplianceHistoryConfiguration() {
  return {
    status: null,
    enableSanctions: null,
    enableShortRegistrationPeriodRiskFactor: null,
    numberOfAnnualChargeLatePaymentYears: null,
    numberOfLtpsLatePaymentYears: null,
    latePaymentWeightingForPreviousYear: null,
    latePaymentWeightingForPreviousYearMinus1: null,
    latePaymentWeightingForPreviousYearMinus2: null,
    latePaymentWeightingForPreviousYearMinus3: null,
    latePaymentWeightingForPreviousYearMinus4: null
  };
}

export function getBlankInformationSessionRecord() {
  return {
    levyCollectionId: null,
    id: null,
    expiryDate: null
  };
}

export function isCurrentLevyCollection(id) {
  return store.state.lookups.loaded && store.state.lookups.data.currentLevyCollections.some(lc => lc.id == id);
}

var ComponentChartColors = ["#3182bd", "#CC435F", "#970D35", "#31a354"];
export { ComponentChartColors };
